import script from "./AddTrackingIdModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTrackingIdModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTrackingIdModal.vue?vue&type=style&index=0&id=deaade42&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deaade42"]])

export default __exports__